import createDOMPurify from 'dompurify';
import sanitize from 'sanitize-html';
/**
 * uses DOMPurify that is preferable. But for server site we have to
 * use JSDOM which makes trouble when building with webpack, so we
 * use sanitize-html for the server site rendering
 */
export function createSanitizeForBrowser() {
    const DOMPurify = createDOMPurify(window);
    return (text) => DOMPurify.sanitize(text, {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br', 'p', 'a', 'sub', 'sup'],
        ALLOWED_ATTR: ['href', 'target']
    });
}
export function createSanitizeForServer() {
    return (text) => sanitize(text, {
        allowedTags: ['b', 'i', 'em', 'strong', 'br', 'p', 'a', 'sub', 'sup'],
        allowedAttributes: {
            a: ['href', 'target']
        }
    });
}
